const isBlank = (value) =>
  value === null || value === undefined || String(value).trim() === "";

/**
 * Validates the create/edit reservation form.
 * @returns {{ ok: true } | { ok: false, message: string }}
 */
export const validateReservationForm = ({
  formData,
}) => {
  // Guest Details
  if (isBlank(formData.guest)) {
    return { ok: false, message: "Guest name is required." };
  }
  if (isBlank(formData.mobile) || formData.mobile === "03") {
    return { ok: false, message: "Mobile number is required." };
  }
  if (!/^03\d{9}$/.test(String(formData.mobile || ""))) {
    return {
      ok: false,
      message: "Mobile number must be 11 digits starting with 03.",
    };
  }
  if (isBlank(formData.passport)) {
    return { ok: false, message: "Passport / CNIC is required." };
  }
  if (!/^\d{1,13}$/.test(String(formData.passport || ""))) {
    return {
      ok: false,
      message: "Passport / CNIC must be digits only (max 13).",
    };
  }
  if (isBlank(formData.adults) || Number(formData.adults) < 1) {
    return { ok: false, message: "Adults must be at least 1." };
  }
  if (isBlank(formData.children) || Number(formData.children) < 0) {
    return { ok: false, message: "Children is required (use 0 if none)." };
  }
  if (isBlank(formData.infants) || Number(formData.infants) < 0) {
    return { ok: false, message: "Infants is required (use 0 if none)." };
  }
  if (isBlank(formData.pets) || Number(formData.pets) < 0) {
    return { ok: false, message: "Pets is required (use 0 if none)." };
  }
  if (isBlank(formData.address)) {
    return { ok: false, message: "Address is required." };
  }

  // Booking Details
  if (isBlank(formData.reservationType)) {
    return { ok: false, message: "Booking status is required." };
  }
  if (isBlank(formData.bookingSource)) {
    return { ok: false, message: "Booking source is required." };
  }
  if (isBlank(formData.checkIn) || isBlank(formData.checkOut)) {
    return {
      ok: false,
      message: "Check-in and check-out dates are required.",
    };
  }
  if (isBlank(formData.hotelId)) {
    return { ok: false, message: "Hotel is required." };
  }

  // Rooms
  if (!formData.rooms?.length) {
    return { ok: false, message: "Please add at least one room." };
  }
  for (let i = 0; i < formData.rooms.length; i++) {
    const room = formData.rooms[i];
    const label = room.name || `Room row ${i + 1}`;
    if (isBlank(room.roomId)) {
      return { ok: false, message: `Room type is required for ${label}.` };
    }
    if (isBlank(room.ratePlanId)) {
      return { ok: false, message: `Rate plan is required for ${label}.` };
    }
    if (
      room.chargeRate === "" ||
      room.chargeRate == null ||
      Number(room.chargeRate) < 0
    ) {
      return { ok: false, message: `Charge rate is required for ${label}.` };
    }
    const assignedId = room.assignedPhysicalRooms?.[0];
    if (isBlank(assignedId)) {
      return {
        ok: false,
        message: `Please assign a physical room for ${label}.`,
      };
    }
  }

  // Payment and booking notes are optional

  return { ok: true };
};
